<template>
  <div>
    <TransfersControllers
      :transfers-selection="transfersSelection"
      @filterTransfers="filterTransfers"
      @filterTransfersFrom="filterTransfersFrom"
      @filterTransfersTo="filterTransfersTo"
      @clearDate="clearDate"/>
    <v-card>
      <search-text-field
        :search-phrase="transferSearch"
        :row-count="transfersRowCount"
        @search="transferSearchRefresh"
      />
      <transfers-datagrid
        :transfer-report-data="transferReportData"
        :transfers-loading="transfersLoading"
        :rows-per-page="transfersRowsPerPage"
        :row-count="transfersRowCount"
        @refreshWithSort="refreshTransfersWithSort"
      />
      <div class="text-xs-center pt-2">
        <pagination
          :selected-page="transfersSelectedPage"
          :rows-per-page="transfersRowsPerPage"
          :row-count="transfersRowCount"
          @changeDisplayedRowCount="transfersChangeDisplayedRowCount"
          @clickedPage="changeTransfersPage"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import SearchTextField from '../../controllers/SearchTextField';
import TransfersControllers from './TransfersControllers';
import TransfersDatagrid from "./TransfersDatagrid";
import Pagination from '../../controllers/Pagination.vue';

    export default {
        name: "TransfersReport",
        components: {TransfersDatagrid, TransfersControllers, Pagination,SearchTextField},
        data ()
        {
            return {
                transferSearch: '',
                transfersRowCount: 0,
                transfersSelectedPage: 1,
                transfersRowsPerPage: 5,
                transfersSorting: {},
                transfersLoading: false,
                transferReportData: [],
                transfersSelection: 'all',
                transfersToDate: null,
                transfersDateFrom: null,
            }
        },
        methods: {
            changeTransfersPage (page)
            {
                let self = this;

                self.transfersSelectedPage = page;
                self.refreshTransfersReportData();
            },
            transfersChangeDisplayedRowCount (rowCount)
            {
              let self= this;

              self.transfersSelectedPage = 1;
              self.transfersRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
              self.refreshTransfersReportData();
            },
            clearDate(target)
            {
                let self = this;

                switch (target) {
                    case 'from':
                        self.transfersDateFrom = null;
                        break;
                    case 'to':
                        self.transfersToDate = null;
                        break;
                }
                self.refreshTransfersReportData();
            },
            filterTransfers (selection)
            {
                this.transfersSelection = selection;
                this.refreshTransfersReportData ();
            },
            filterTransfersFrom (from)
            {
                let self = this;
                self.transfersDateFrom = from;
                self.refreshTransfersReportData();
            },
            filterTransfersTo (to)
            {
                let self = this;
                self.transfersToDate = to;
                self.refreshTransfersReportData();
            },

            refreshTransfersWithSort (pagination)
            {
                let self = this;

                self.transfersSorting = {};
                self.transfersSorting[pagination.sortBy] = pagination.descending ? 'desc' : 'asc';
                self.refreshTransfersReportData ();
            },
            transferSearchRefresh (search)
            {
              let self = this;

              if (search !== '')
              {
                self.transfersSelectedPage = 1
              }
              self.transferSearch = search;
              self.refreshTransfersReportData();
            },
            refreshTransfersReportData ()
            {

                let self = this;

                self.transfersLoading = true;
                let transfersFetch = self.$store.dispatch('transfers/getTransfersReport', {page: self.transfersSelectedPage, rowsPerPage: self.transfersRowsPerPage, from: self.transfersDateFrom, to: self.transfersToDate, selection: self.transfersSelection, sort: self.transfersSorting, search: self.transferSearch });
                transfersFetch.then(response =>
                    {
                        self.processTransfersReport(response);
                        self.transfersLoading = false;
                    }, () =>
                    {
                        // error
                        self.transfersLoading = false;
                    }
                );
            },
            processTransfersReport (obj)
            {
                let self = this;

                let transfersReports = obj.Rows;
                self.transferReportData = [];
                for (let transfersReport of transfersReports)
                {
                    let transfersReportClient = {
                        batchTransferId: transfersReport.BatchTransferId,
                        objectId: transfersReport.ObjectId,
                        objectType: transfersReport.ObjectType,
                        reference: transfersReport.Reference,
                        transferDate: transfersReport.TransferDate,
                        amount: transfersReport.Amount,
                        created: transfersReport.Created
                    };
                    self.transferReportData.push(transfersReportClient);
                }
                self.transfersRowCount = obj.TotalRowCount;
            }
        }
    }
</script>

<style scoped>

</style>
